/** @format */

import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

import {BarColor} from '../helpers';

const Root = styled(Box, {
  shouldForwardProp: prop => prop !== 'value' && prop !== 'bgColor',
})<{value: number; bgColor: BarColor}>(({theme, value, bgColor}) => ({
  maxWidth: '100px',
  width: `${value}%`,
  minWidth: `${value > 0 ? '8px' : 'auto'}`,
  height: '8px',
  background: bgColor === 'red' ? '#EA5759' : bgColor === 'yellow' ? '#DDA14D' : '#749F23',
  marginLeft: theme.spacing(2),
  borderRadius: '8px',
}));

interface Props {
  bgColor: BarColor;
  value: number;
}

const ResolvedLine = (props: Props) => {
  return <Root value={props.value} bgColor={props.bgColor} />;
};

export default ResolvedLine;
